export const cellAlignment = (numeric: boolean|undefined): 'right'|'left' => {
    if (numeric) {
        return 'right';
    }
    
    return 'left';
};
export const isUndefined = (a: any) => typeof a === 'undefined';
export const isExpandingCell = (width: number|undefined) => isUndefined(width);
